module.exports = __webpack_public_path__ + "img/sim.75ed166d.png";